var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrandadminlogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5813_12911",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H24V24H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5813_12911)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9453 15.3398H1.05469C0.667969 15.3398 0.351562 15.0234 0.351562 14.6367V9.36328C0.351562 8.97656 0.667969 8.66016 1.05469 8.66016H22.9453C23.332 8.66016 23.6484 8.97661 23.6484 9.36328V14.6367C23.6484 15.0234 23.332 15.3398 22.9453 15.3398H13.0547M12.3516 15.3398H11.6484",
    stroke: "#656565",
    strokeMiterlimit: 22.926
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07481 8.66016L2.00586 6.22852L4.74912 4.74675L6.23089 2.00349L9.34751 2.09185L12.0024 0.457033L14.6573 2.09185L17.7739 2.00349L19.2557 4.74675L21.9989 6.22852L21.93 8.66016M21.93 15.3398L21.9989 17.7715L19.2557 19.2532L17.7739 21.9965L14.6573 21.9082L12.0024 23.543L9.34751 21.9082L6.23089 21.9965L4.74912 19.2532L2.00586 17.7715L2.07481 15.3398",
    stroke: "#656565",
    strokeMiterlimit: 22.926
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.66217 4.76208C8.92972 4.00059 10.4137 3.5625 12.0001 3.5625C15.4735 3.5625 18.4563 5.66156 19.7502 8.66016M4.25 8.66016C4.85872 7.24941 5.84136 6.03792 7.07291 5.1503M19.7502 15.3398C18.4563 18.3385 15.4735 20.4375 12.0001 20.4375C8.52669 20.4375 5.54394 18.3385 4.25 15.3398",
    stroke: "#656565",
    strokeMiterlimit: 22.926
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8672 6.72656V6.02344M14.4609 6.02339V5.32027",
    stroke: "#656565",
    strokeWidth: 0.703125,
    strokeMiterlimit: 2.613
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5352 13.3862L11.6042 10.5792L11.7237 10.579L12.783 13.3862",
    stroke: "#656565",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8691 12.687H12.4555",
    stroke: "#656565",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9805 13.4209V10.5791L15.1053 10.5791L16.8634 13.377H16.9884V10.5738",
    stroke: "#656565",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9588 11.9552C20.9588 12.7164 20.5363 13.3249 19.866 13.3367H19.0605V10.5737H19.843C20.5783 10.5737 20.9588 11.1939 20.9588 11.9552Z",
    stroke: "#656565",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.18359 11.8901H4.01445C4.43769 11.8901 4.78081 12.2332 4.78081 12.6565C4.78081 13.0797 4.43769 13.4263 4.01445 13.4263H3.04297V10.5791H3.86998C4.23181 10.5791 4.52516 10.8724 4.52516 11.2342C4.52516 11.5961 4.23186 11.8901 3.87003 11.8901",
    stroke: "#656565",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.36719 12.2468L8.30544 13.356",
    stroke: "#656565",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99837 12.0623L7.60906 12.059C8.03253 12.059 8.39089 11.7277 8.39089 11.3191C8.39089 10.9104 8.03253 10.5791 7.60906 10.5791H6.85203L6.85156 13.4263",
    stroke: "#656565",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandadminlogo);
export default __webpack_public_path__ + "static/media/Brandadminlogo.74ea9f8dde91092a596b37f0ae0424e1.svg";
export { ForwardRef as ReactComponent };